import script from "./HighlightAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./HighlightAdminPage.vue?vue&type=style&index=0&id=9d4e29b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d4e29b6"]])

export default __exports__